import { storeToRefs } from "pinia";

import { useAiAgentsStore } from "@/stores/ai/agents";

import type { AiAgentSessionMessage } from "@/models/aiAgents";

export const handleAiAgentSessionsEvent = async (
  message: AiAgentSessionMessage
) => {
  const { agentSessionInfo } = storeToRefs(useAiAgentsStore());

  if (
    !agentSessionInfo.value.activeSession?.id ||
    agentSessionInfo.value.activeSession.id !== message.ai_agent_session_id
  ) {
    return;
  }

  agentSessionInfo.value.activeSession.messages?.push(message);
};
